import React, { useState, useEffect } from "react";
import { useMsal, AuthenticatedTemplate } from "@azure/msal-react";
import { Sidebar, useProSidebar } from "react-pro-sidebar";
import MenuIcon from "@mui/icons-material/Menu";
import SidebarMenu from "./SidebarMenu"; // 👈 import component ที่แยกไว้

const SideBar = () => {
  const { collapseSidebar } = useProSidebar();

  const [toggled, setToggled] = useState(false);

  return (
    <div
      id="app"
      style={{
        display: "flex",
        flexDirection: "row-reverse",
      }}
    >
      <AuthenticatedTemplate>
        <main style={{ display: "flex", padding: 0 }}>
          <button className="sb-button" onClick={() => setToggled(!toggled)}>
            <MenuIcon style={{ color: "#0078d4" }} />
          </button>
        </main>
        <Sidebar
          className="app"
          onBackdropClick={() => setToggled(false)}
          toggled={toggled}
          breakPoint="always"
          rtl={true}
        >
          {/* 👇 เรียกใช้ component เมนู */}
          <SidebarMenu />
        </Sidebar>
      </AuthenticatedTemplate>
    </div>
  );
};

export default SideBar;
